// 💾 src/pages/public/FutureTrade.tsx
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { getAuth } from "firebase/auth"
import { getFirestore, collection, addDoc, serverTimestamp } from "firebase/firestore"
import { ToastContainer } from "react-toastify"
import ChartSection from "../../components/trade/ChartSection"
import PairList from "../../components/trade/PairList"
import OrderBook from "../../components/trade/OrderBook"
import RecentTrades from "../../components/trade/RecentTrades"
import TradeForm from "../../components/trade/TradeForm"
import OpenOrders from "../../components/trade/OpenOrders"
import TradeAnalytics from "../../components/trade/TradeAnalytics"
import OrderHistory from "../../components/trade/OrderHistory"
import "../public/style/SpotTrade.scss"

import { useUserTrades } from "../../hooks/useUserTrades"
import { OpenOrder } from "../../types/orders"

const auth = getAuth()
const db = getFirestore()


const FutureTrade = () => {
  const { pair = "BTC_USDT" } = useParams()
  const [activeTab, setActiveTab] = useState<"orderbook" | "trades">("orderbook")
  type FooterTab = "open" | "history" | "trades" | "positions"
  const [footerTab, setFooterTab] = useState<FooterTab>("open")
  const allTrades = useUserTrades()
  const openOrders = allTrades.filter((o) => o.status === "OPEN")
  const orderHistory = allTrades.filter((o) => o.status !== "OPEN")
  console.log("Trades:", allTrades)


  const handleNewOrder = async (order: any) => {
    const user = auth.currentUser
    if (!user) return alert("Please login to trade")

    const now = new Date()

    try {
      await addDoc(collection(db, "users", user.uid, "trades"), {
        crypto: pair.replace("_", "/"), // BTC_USDT → BTC/USDT
        tradeAction: order.side?.toUpperCase(), // BUY or SELL
        tradeAmount: order.amount, // USDT
        tradePrice: order.price, // entry price
        createdAt: now,
        status: "OPEN"
      })
    } catch (err) {
      console.error("[FutureTrade] Failed to place order", err)
    }
  }

  return (
    <div className="spot-trade-layout">
      <aside className="pair-list">
        <PairList selectedPair={pair} />
      </aside>

      <section className="chart-and-book horizontal">
        <div className="chart">
          <ChartSection pair={pair} />
        </div>

        <div className="orderbook-and-trades">
          <div className="tab-header">
            <button
              className={activeTab === "orderbook" ? "active" : ""}
              onClick={() => setActiveTab("orderbook")}
            >
              Order Book
            </button>
            <button
              className={activeTab === "trades" ? "active" : ""}
              onClick={() => setActiveTab("trades")}
            >
              Recent Trades
            </button>
          </div>

          <div className="tab-content">
            {activeTab === "orderbook" ? (
              <OrderBook pair={pair} />
            ) : (
              <RecentTrades pair={pair} />
            )}
          </div>
        </div>
      </section>

      <section className="trade-panel">
        <div className="spot-form">
          <TradeForm pair={pair} onNewOrder={handleNewOrder} />
        </div>
        <div className="wallet-buttons">
          <button>Deposit</button>
          <button>Withdraw</button>
        </div>
      </section>
             <ToastContainer position="top-right" autoClose={5000} />
      <footer className="trade-footer">
        <ul>
          <li
            className={footerTab === "open" ? "active" : ""}
            onClick={() => setFooterTab("open")}
          >
            Open Orders
          </li>
          <li
            className={footerTab === "history" ? "active" : ""}
            onClick={() => setFooterTab("history")}
          >
            Order History
          </li>
          <li
            className={footerTab === "trades" ? "active" : ""}
            onClick={() => setFooterTab("trades")}
          >
            Trade History
          </li>
          <li
            className={footerTab === "positions" ? "active" : ""}
            onClick={() => setFooterTab("positions")}
          >
            Positions
          </li>
        </ul>

       <div style={{ padding: "1rem 0" }}>
        {footerTab === "open" && <OpenOrders orders={openOrders} />}
        {footerTab === "history" && <OrderHistory />}
        {/* add other tabs here */}
      </div>

      </footer>
    </div>
  )
}

export default FutureTrade
